import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './components/auth/RequireAuth';
import { RequireCanManageLayers } from './components/auth/RequireCanManageLayers';
import { ToastProvider } from './components/ui/Toast';
import { AdminDataProvider } from './admin/AdminDataContext';
import { WorkspaceGate } from './pages/WorkspaceGate';
import { DataLayersPage } from './pages/admin/DataLayersPage';
import { AddLayerPage } from './pages/admin/AddLayerPage';
import { EditLayerPage } from './pages/admin/EditLayerPage';
import { LayerRegistryTablePage } from './pages/admin/LayerRegistryTablePage';
import { ObjectCardPage } from './pages/admin/ObjectCardPage';
import { MapSettingsPage } from './pages/admin/MapSettingsPage';
import { EmbedMapPage } from './pages/EmbedMapPage';
import { DictionariesListPage } from './pages/admin/DictionariesListPage';
import { AddDictionaryPage } from './pages/admin/AddDictionaryPage';
import { DictionaryDetailPage } from './pages/admin/DictionaryDetailPage';
import { DictionaryValueCardPage } from './pages/admin/DictionaryValueCardPage';
import { LoginPage } from './pages/auth/LoginPage';
import { MfaPage } from './pages/auth/MfaPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { ResetPasswordConfirmPage } from './pages/auth/ResetPasswordConfirmPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { WorkspaceChoicePage } from './pages/auth/WorkspaceChoicePage';
import { AuditLogPage } from './pages/app/AuditLogPage';
import { OrganizationSettingsPage } from './pages/app/OrganizationSettingsPage';
import { ProfileSettingsPage } from './pages/app/ProfileSettingsPage';
import { ReportsPage } from './pages/app/ReportsPage';
import { TasksPage } from './pages/app/TasksPage';

function App() {
  return (
    <ToastProvider>
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/embed/:token" element={<EmbedMapPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/reset-password/confirm" element={<ResetPasswordConfirmPage />} />
      <Route
        path="/workspace"
        element={
          <RequireAuth>
            <WorkspaceChoicePage />
          </RequireAuth>
        }
      />
      <Route path="/mfa" element={<MfaPage />} />
      <Route
        path="/app"
        element={
          <RequireAuth>
            <AdminDataProvider>
              <WorkspaceGate />
            </AdminDataProvider>
          </RequireAuth>
        }
      />
      <Route
        path="/app/profile"
        element={
          <RequireAuth>
            <ProfileSettingsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/app/organization"
        element={
          <RequireAuth>
            <OrganizationSettingsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/app/organization/audit-log"
        element={
          <RequireAuth>
            <AuditLogPage />
          </RequireAuth>
        }
      />
      <Route
        path="/app/tasks"
        element={
          <RequireAuth>
            <TasksPage />
          </RequireAuth>
        }
      />
      <Route
        path="/app/reports"
        element={
          <RequireAuth>
            <AdminDataProvider>
              <ReportsPage />
            </AdminDataProvider>
          </RequireAuth>
        }
      />
      <Route
        path="/app/data"
        element={
          <RequireAuth>
            <AdminDataProvider>
              <DataLayersPage />
            </AdminDataProvider>
          </RequireAuth>
        }
      />
      <Route
        path="/app/data/add"
        element={
          <RequireAuth>
            <RequireCanManageLayers>
              <AdminDataProvider>
                <AddLayerPage />
              </AdminDataProvider>
            </RequireCanManageLayers>
          </RequireAuth>
        }
      />
      <Route
        path="/app/data/edit/:layerId"
        element={
          <RequireAuth>
            <RequireCanManageLayers>
              <AdminDataProvider>
                <EditLayerPage />
              </AdminDataProvider>
            </RequireCanManageLayers>
          </RequireAuth>
        }
      />
      <Route
        path="/app/data/layers/:layerId/table"
        element={
          <RequireAuth>
            <AdminDataProvider>
              <LayerRegistryTablePage />
            </AdminDataProvider>
          </RequireAuth>
        }
      />
      <Route
        path="/app/data/layers/:layerId/objects/:featureId"
        element={
          <RequireAuth>
            <AdminDataProvider>
              <ObjectCardPage />
            </AdminDataProvider>
          </RequireAuth>
        }
      />
      <Route
        path="/app/dictionaries"
        element={
          <RequireAuth>
            <DictionariesListPage />
          </RequireAuth>
        }
      />
      <Route
        path="/app/dictionaries/add"
        element={
          <RequireAuth>
            <RequireCanManageLayers>
              <AddDictionaryPage />
            </RequireCanManageLayers>
          </RequireAuth>
        }
      />
      <Route
        path="/app/dictionaries/:dictionaryId"
        element={
          <RequireAuth>
            <RequireCanManageLayers>
              <DictionaryDetailPage />
            </RequireCanManageLayers>
          </RequireAuth>
        }
      />
      <Route
        path="/app/dictionaries/:dictionaryId/values/:valueId"
        element={
          <RequireAuth>
            <RequireCanManageLayers>
              <DictionaryValueCardPage />
            </RequireCanManageLayers>
          </RequireAuth>
        }
      />
      <Route path="/app/basemaps" element={<Navigate to="/app/map-settings" replace />} />
      <Route
        path="/app/map-settings"
        element={
          <RequireAuth>
            <RequireCanManageLayers>
              <AdminDataProvider>
                <MapSettingsPage />
              </AdminDataProvider>
            </RequireCanManageLayers>
          </RequireAuth>
        }
      />
    </Routes>
    </ToastProvider>
  );
}

export default App;
